export default () => ({
  title: "",
  units:[],
  unitsForCurrentUser:[],
  unit:null,
  section:[],
  unitToEdit: '',
  status: '',
  total: "",
  monitoringDoctors : [],
});
